<div class="container">
	<div [inlineSVG]="'/assets/img/logo-hps.svg'" class="logo"></div>
	<h1>Aláírás generátor</h1>

	<form #f="ngForm" (ngSubmit)="save()" class="form" novalidate>
		<div class="row">
			<div class="col-md-4">
				<div class="form-group">
					<label>Név</label>
					<input type="text" class="form-control" name="name" [(ngModel)]="signature.name" #name="ngModel" (input)="preview()" required>
				</div>
				<div class="form-group">
					<label>E-mail</label>
					<input type="email" class="form-control" name="email" [(ngModel)]="signature.email" #email="ngModel" (input)="preview()" required>
				</div>

				<div class="form-group">
					<label>Cég</label>
					<ng-select [items]="companies" [(ngModel)]="signature.company" [ngModelOptions]="{standalone: true}" [clearable]="false" (change)="preview()"></ng-select>
				</div>

				<div *ngIf="signature.company === 'HPS Communication'" class="form-group">
					<label>Divízió</label>
					<ng-select [items]="divisonsCommunication" [(ngModel)]="signature.division" [ngModelOptions]="{standalone: true}" [clearable]="false" (change)="preview()"></ng-select>
				</div>
				<div *ngIf="signature.company === 'HPS Trade'" class="form-group">
					<label>Divízió</label>
					<ng-select [items]="divisonsTrade" [(ngModel)]="signature.division" [ngModelOptions]="{standalone: true}" [clearable]="true" (change)="preview()"></ng-select>
				</div>
				<div class="form-group">
					<label>Pozíció</label>
					<ng-select [items]="positions" [(ngModel)]="signature.position" [ngModelOptions]="{standalone: true}" [clearable]="false" (change)="preview()"></ng-select>
				</div>
				<div class="form-group">
					<label>Telefonszám</label>
					<div class="input-group">
						<div class="input-group-prepend">
							<div class="input-group-text">+36</div>
						</div>
						<input type="tel" class="form-control" maxlength="9" name="phone" [(ngModel)]="signature.phone" #phone="ngModel" (input)="preview()" required>
					</div>
				</div>
			</div>

			<div class="col-md-8">
				<h3>Előnézet</h3>

				<div class="preview">
					<iframe [src]="signaturePreview"></iframe>
					<div class="overlay"></div>
				</div>

				<p class="d-block d-md-none">
					<button [disabled]="f.form.invalid || !signature.division" type="submit" class="btn btn-primary btn-lg">Generálás</button>
				</p>
			</div>
		</div>
	</form>

	<hr>
</div>

<div class="container-fluid">
	<div class="row">
		<div class="col-md-4">
			<h4 class="text-center">Outlook <small class="text-muted">- Windows</small></h4>
			<div class="card">
				<div class="card-body">
					<ol>
						<li>
							Kijelölés-másolás:<br>
							<code class="block">powershell.exe -Command "IEX (New-Object System.Net.Webclient).DownloadString('https://raw.githubusercontent.com/hpsdigital/SignatureInstaller/master/outlook-windows.ps1')"</code>
						</li>
						<li>
							<small class="text-muted">[WIN]</small>+<small class="text-muted">[R]</small> gombok:
							<code>cmd</code> <small class="text-muted">[ENTER]</small>
						</li>
						<li>
							<b>Parancssor</b>ba beillesztés
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							Kijelölés-másolás:<br>
							<code class="block">{{ url + signatureUrl }}</code>
						</li>
						<li>
							Váltás <b>Parancssor</b>ra és várakozás <i class="small">enter url</i> kiírásra
						</li>
						<li>
							Beillesztés
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							<b>Outlook</b> megnyitás -> Fájl -> Beállítások -> Levelek -> Aláírások
						</li>
						<li>
							<i>Alapértelmezett aláírás kiválasztása</i>:<br>
							<i>E-mail fiók</i>: HPS<br>
							<i>Új üzenetek</i>: <code>signature</code> megadása<br>
							<i>Válasz/Továbbítás</i>: <code>signature</code> megadása
						</li>
					</ol>
					<div class="text-center mt-3 small">
						<a href="https://support.office.com/hu-hu/article/alá%C3%ADrás-létrehozása-és-hozzáadása-az-üzenetekhez-8ee5d4f4-68fd-464a-a1c1-0e1c80bb27f2?ui=hu-HU&rs=hu-HU&ad=HU" target="_blank">További segédlet</a>
					</div>

					<div class="text-center mt-3 small">
						<button type="button" class="btn btn-outline-primary btn-sm btn-problem" (click)="isOutlookWinStringCollapsed = !isOutlookWinStringCollapsed"
								[attr.aria-expanded]="!isOutlookWinStringCollapsed">
							Hibát ír ki?
						</button>
					</div>
				</div>
			</div>

			<div class="card mt-2" [ngbCollapse]="isOutlookWinStringCollapsed">
				<div class="card">
					<div class="card-body">
						<div>
							<p>
								Ha azt a hibaüzenet írja ki futtatáskor, hogy "Bezárták az alapul szolgáló kapcsolatot", akkor próbáld a következő lépéseket:
							</p>
						</div>
						<ol>
							<li>
								Kijelölés-másolás:<br>
								<code class="block">powershell.exe -Command "IEX (New-Object System.Net.Webclient).DownloadString('https://raw.githubusercontent.com/hpsdigital/SignatureInstaller/master/outlook-windows-string.ps1')"</code>
							</li>
							<li>
								<small class="text-muted">[WIN]</small>+<small class="text-muted">[R]</small> gombok:
								<code>cmd</code> <small class="text-muted">[ENTER]</small>
							</li>
							<li>
								<b>Parancssor</b>ba beillesztés
								<small class="text-muted">[ENTER]</small>
							</li>
							<li>
								Nyisd meg böngészőben ezt a linket<br>
								<a href="{{ url + signatureUrl + '&code=1' }}" target="_blank">{{ url + signatureUrl + '&code=1' }}</a>
							</li>
							<li>
								Jelöld ki az egészet és másold ki
							</li>
							<li>
								Váltás <b>Parancssor</b>ra és várakozás <i class="small">enter signature</i> kiírásra
							</li>
							<li>
								Beillesztés
								<small class="text-muted">[ENTER]</small>
							</li>
							<li>
								<b>Outlook</b> megnyitás -> Fájl -> Beállítások -> Levelek -> Aláírások
							</li>
							<li>
								<i>Alapértelmezett aláírás kiválasztása</i>:<br>
								<i>E-mail fiók</i>: HPS<br>
								<i>Új üzenetek</i>: <code>signature</code> megadása<br>
								<i>Válasz/Továbbítás</i>: <code>signature</code> megadása
							</li>
						</ol>
					</div>
				</div>
			</div>
		</div>

		<div class="col-md-4">
			<h4 class="text-center">Outlook <small class="text-muted">- macOS</small></h4>
			<div class="card">
				<div class="card-body">
					<ol>
						<li>
							Kijelölés-másolás:<br>
							<code class="block">curl https://raw.githubusercontent.com/hpsdigital/SignatureInstaller/master/outlook-mac.sh | bash</code>
						</li>
						<li>
							<small class="text-muted">[CMD]</small>+<small class="text-muted">[SPACE]</small> gombok:
							<code>Terminal</code>
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							Beillesztés
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							Kijelölés-másolás:<br>
							<code class="block">{{ url + signatureUrl }}</code>
						</li>
						<li>
							Váltás <b>Terminal</b>ra és várakozás <i class="small">enter url</i> kiírásra
						</li>
						<li>
							Beillesztés
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							<b>Outlook</b> megnyitás -> Beállítások -> Aláírások
						</li>
						<li>
							<i>Alapértelmezett aláírás kiválasztása</i>:<br>
							<i>Fiók</i>: HPS<br>
							<i>Új üzenetek</i>: <code>signature</code> megadása<br>
							<i>Válasz/Továbbítás</i>: <code>signature</code> megadása
						</li>
					</ol>
					<div class="text-center mt-3 small">
						<a href="https://support.office.com/hu-hu/article/alá%C3%ADrás-létrehozása-és-beszúrása-a-mac-outlookban-f4d21492-0956-4429-95ad-2769745b539c" target="_blank">További segédlet</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-md-4">
			<h4 class="text-center">Mail <small class="text-muted">- macOS</small></h4>

			<div class="card">
				<div class="card-body">
					<ol>
						<li>
							<b>Mail</b> megnyitás -> Beállítások
						</li>
						<li>
							Aláírások fül -> HPS fiókra váltás, <code>+</code> hozzáadás<br>
							<i>(nem kell kitöltened semmit)</i>
						</li>
						<li>
							<b>Mail</b> bezárása
						</li>
						<li>
							Kijelölés-másolás:<br>
							<code class="block">curl https://raw.githubusercontent.com/hpsdigital/SignatureInstaller/master/apple-mail.sh | bash</code>
						</li>
						<li>
							<small class="text-muted">[CMD]</small>+<small class="text-muted">[SPACE]</small> gombok:
							<code>Terminal</code>
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							Beillesztés
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							Kijelölés-másolás:<br>
							<code class="block">{{ url + signatureUrl }}&br=1</code>
						</li>
						<li>
							Váltás <b>Terminal</b>ra és várakozás <i class="small">enter url</i> kiírásra
						</li>
						<li>
							Beillesztés
							<small class="text-muted">[ENTER]</small>
						</li>
						<li>
							<b>Mail</b> megnyitás -> Beállítások
						</li>
						<li>
							Aláírások fül -> HPS fiókra váltás<br>
							<i>Aláírás kiválasztása</i> legördülőben az új aláírás megadása
						</li>
					</ol>
					<div class="text-center mt-3 small">
						<a href="https://support.apple.com/hu-hu/guide/mail/mail11943/mac" target="_blank">További segédlet</a>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="text-center small mt-3">
			<strong>Fontos, hogy az elkészült aláíráson ne módosíts, ha változás van menj végig újra a folyamaton!</strong>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/home/home.html